import {SidebarItemsType} from '../../types/sidebar';
import AuditPLogo from "../../assets/icons/CustomSvg/AuditPage";
import Jira from "../../assets/icons/CustomSvg/Jira";
import Notion from "../../assets/icons/CustomSvg/Notion";
import Shopify from "../../assets/icons/CustomSvg/Shopify";
import Chatgpt from "../../assets/icons/CustomSvg/Chatgpt";
import Claude from "../../assets/icons/CustomSvg/Claude";
import Trello from "../../assets/icons/CustomSvg/Trello";
import GitHub from "../../assets/icons/CustomSvg/GitHub";
import Gitlab from "../../assets/icons/CustomSvg/Gitlab";
import {Driver, Messages3, Setting2, Shield} from "iconsax-reactjs";
import AddAppPLogo from "../../assets/icons/CustomSvg/AddAppPage";

export const dashboardSection = [
  {
    href: '/',
    icon: Driver,
    title: 'common.default_pages.dashboard',
  },
  {
    href: '/app-connector',
    icon: AddAppPLogo,
    title: 'common.default_pages.app_connector',
  },

  {
    href: '/audit',
    icon: AuditPLogo,
    title: 'common.default_pages.audit_trail',
  },

] as SidebarItemsType[];

export const servicesSection = [
  {
    href: 'contact',
    icon: Messages3,
    title: 'common.default_pages.support',
  },
  {
    href: '/subscriptions',
    icon: Shield,
    title: 'common.default_pages.subscriptions',
  },
  {
    href: '/settings',
    icon: Setting2,
    title: 'common.default_pages.profile',
  },
] as SidebarItemsType[]

export const integrationsSection = [
  {
    href: '/platform/dashboard/github',
    icon: GitHub,
    title: 'common.platforms.github',
  },
  {
    href: '/platform/dashboard/trello',
    icon: Trello,
    title: 'common.platforms.trello',
  },
  {
    href: '/platform/dashboard/gitlab',
    icon: Gitlab,
    title: 'common.platforms.gitlab',
  },
  {
    href: '/platform/dashboard/jira',
    icon: Jira,
    title: 'common.platforms.jira'
  },
  {
    href: '/platform/dashboard/notion',
    icon: Notion,
    title: 'common.platforms.notion'
  },
  {
    href: '/platform/dashboard/shopify',
    icon: Shopify,
    title: 'common.platforms.shopify'
  },
  {
    href: '/platform/dashboard/chatgpt',
    icon: Chatgpt,
    title: 'common.platforms.chatgpt'
  },
  {
    href: '/platform/dashboard/claude',
    icon: Claude,
    title: 'common.platforms.claude'
  },
] as SidebarItemsType[];

const navItems = [
  {
    title: 'Main',
    pages: dashboardSection,
  },
  {
    title: 'common.default_pages.integrations',
    pages: integrationsSection,
  },
  {
    title: '',
    pages: servicesSection,
  }
];

export default navItems;
